import { useMemo } from 'react'
import { NavLink } from 'react-router-dom'
import {
  HiOutlineNewspaper,
  HiOutlineMap,
  HiOutlineLocationMarker,
  HiOutlineFolderOpen,
  HiOutlineOfficeBuilding,
} from 'react-icons/hi'
import clsx from 'clsx'
import { usePermissions } from '../../hooks/usePermissions'

// 5 menu items chính với permission keys
const navItems = [
  {
    to: '/news',
    icon: HiOutlineNewspaper,
    label: 'Tin tức',
    featureKey: 'news',
    activeColor: 'text-blue-600',
    activeBg: 'bg-blue-50',
    indicatorColor: 'bg-blue-600',
  },
  {
    to: '/projects',
    icon: HiOutlineOfficeBuilding,
    label: 'Dự án',
    featureKey: 'projects',
    activeColor: 'text-cyan-600',
    activeBg: 'bg-cyan-50',
    indicatorColor: 'bg-cyan-600',
  },
  {
    to: '/docs',
    icon: HiOutlineFolderOpen,
    label: 'Tài liệu',
    featureKey: 'docs',
    activeColor: 'text-orange-600',
    activeBg: 'bg-orange-50',
    indicatorColor: 'bg-orange-600',
  },
  {
    to: '/map',
    icon: HiOutlineMap,
    label: 'Bản đồ giá',
    featureKey: 'map',
    activeColor: 'text-emerald-600',
    activeBg: 'bg-emerald-50',
    indicatorColor: 'bg-emerald-600',
  },
  {
    to: '/maps',
    icon: HiOutlineLocationMarker,
    label: 'Tạo bản đồ',
    featureKey: 'maps',
    activeColor: 'text-purple-600',
    activeBg: 'bg-purple-50',
    indicatorColor: 'bg-purple-600',
  },
]

// V1: Bottom navigation đơn giản, đẹp, màu sắc đặc trưng cho từng mục
function BottomNav() {
  const { hasAccess } = usePermissions()

  // Filter nav items based on permissions
  const visibleNavItems = useMemo(() => {
    return navItems.filter(item => hasAccess(item.featureKey))
  }, [hasAccess])
  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white backdrop-blur-sm border-t border-secondary-100 md:hidden safe-bottom z-40 shadow-lg ">
      <div className="flex items-center justify-around h-16 px-2">
        {visibleNavItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              clsx(
                'flex flex-col items-center justify-center flex-1 h-full py-2',
                'text-xs transition-all duration-200 relative',
                isActive ? item.activeColor : 'text-secondary-400'
              )
            }
          >
            {({ isActive }) => (
              <>
                {/* Active indicator */}
                {isActive && (
                  <div className={clsx(
                    'absolute top-0 left-1/2 -translate-x-1/2 w-10 h-1 rounded-b-full',
                    item.indicatorColor
                  )} />
                )}

                <div className={clsx(
                  'p-1.5 rounded-xl transition-all',
                  isActive && item.activeBg
                )}>
                  <item.icon className="w-5 h-5" />
                </div>

                <span className={clsx(
                  'mt-0.5',
                  isActive ? 'font-semibold' : 'font-medium'
                )}>
                  {item.label}
                </span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  )
}

export default BottomNav
